module.exports = __webpack_public_path__ + "img/facebook.6c51b393.svg";